
import React, {useState} from 'react';
import {connect} from 'react-redux';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import {formatPhone} from '../ApplicationHelpers';
import axios from 'axios';

function ContactInfo(props) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        try{
            await axios({
               method: 'post',
               url: '/92know/contactToAdvisor',
               data: props.getForm()
             });
             setShow(true);
           }catch(ex){
               console.log(ex);
           setShow(true);
           }
    }
    let {user} = props;
    let form = props.getForm();
    let nineToknowVideLink = form.nineToknowVideLink;
            if(!user || typeof user !== 'object'){
                return <p>Your advisor has been notified with an email!</p>;
            }
            if(user.info && user.info.address){
                user.info.address = user.info.address.replace('<br>',', ')
            }
            return (
                <React.Fragment>
                <div style={{'paddingBottom':'15px'}}>
                    <Button variant="primary" onClick={handleShow} style={{'verticalAlign':'inherit','float':'left'}}>
                    Contact {props.user && props.user.firstName ? props.user.firstName:"Advisor" }
                    </Button>
                    <Button variant="primary" style={{'verticalAlign':'inherit','float':'right'}} onClick={() => props.processResult(false)} >Edit Information</Button>
                    <br></br>
                </div>
                <Modal
                size="md"
                centered
                show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Advisor Contact Info</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={12} sm={6} md={4}>
                            <img
                            alt="RA Logo"
                            src={ user.avatar || "http://placehold.it/380x500"}
                            className="d-inline-block align-top img-rounded img-responsive"
                            centered={'true'}
                            style={{"width":"100%"}}
                            />
                        </Col>
                        <Col xs={12} sm={6} md={8}>
                       <h4>{user.firstName} {user.lastName}</h4>
                            <p
                            style={{"marginBottom":"0px"}}
                            >
                                <img
                                alt="RA Logo"
                                src="/92know/images/envelop.png"
                                className="d-inline-block align-top img-rounded img-responsive"
                                centered={'true'}
                                style={{"width":"13px","marginTop":"7px","marginRight":"5px"}}
                                />
                                {user.email}
                                <br />
                                {user.info &&
                                <React.Fragment>
                                <img
                                alt="RA Logo"
                                src="/92know/images/phone.png"
                                className="d-inline-block align-top img-rounded img-responsive"
                                centered={'true'}
                                style={{"width":"13px","marginTop":"5px","marginRight":"5px"}}
                                />
                                {formatPhone(user.info.ophone || user.info.mphone )}
                                </React.Fragment>
                                }
                            </p>
                            {user.info && user.info.address  &&
                                <small>
                                <img
                                alt="RA Logo"
                                src="/92know/images/pin.png"
                                className="d-inline-block align-top img-rounded img-responsive"
                                centered={'true'}
                                style={{"width":"13px","marginTop":"2px"}}
                                />
                                <cite title="San Francisco, USA">{user.info.address}
                                </cite>
                                </small>
                            }
                            <br/>
                            <small>*An automated email has been generated and sent to {user ? user.firstName:'the advisor'}!</small>
                        </Col>
                    </Row>
                    <br></br>
                    {nineToknowVideLink && nineToknowVideLink !== '' &&
                        <Row>
                            <Col md={12} xs={12} sm={12}>
                                <video style={{'width':'100%'}} controls autoPlay={true}>
                                    <source src={nineToknowVideLink} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </Col>
                        </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                    Close
                    </Button>
                </Modal.Footer>
                </Modal>
            </React.Fragment>
    );
  }
  const mapStateToProps = (state, ownProps) => {
    return {
        form:state.mainState.form,
        user: state.mainState.form.user,
        ...state.mainState,
        ...ownProps
    }
  }

//   const mapDispatchToProps = { globalUpdateState }

  export default connect(
    mapStateToProps,
    null
    // mapDispatchToProps
  )(ContactInfo)
